import React from "react";
import Card from "./Card";
import BarTrack from "./BarTrack";
import { formatCurrency } from "../utils/format";
import { useAutoScrollList } from "../hooks/useAutoScrollList";

// Kolom 1 - welke diensten deze maand het meest zijn verkocht.
//
// React.memo: anders krijgt de kaart bij elke klok-tick een nieuwe identiteit
// en begint het doorrollen elke minuut opnieuw.
const MostSoldServices = React.memo(({ soldServices, monthLabel }) => {
  const { viewportRef, listRef, gap, duration } =
    useAutoScrollList(soldServices);

  const maxValue = soldServices.length
    ? Math.max(...soldServices.map((service) => service.totalPrice))
    : 0;

  const rows = soldServices.map((service, index) => (
    <div
      key={index}
      className="service-row animate-fade-in"
      style={{ animationDelay: `${index * 0.06}s` }}
    >
      <div className="nm">
        <span className="nm-text">{service.name}</span>
        {service.count > 1 && <span className="nm-count">{service.count}x</span>}
      </div>
      <div className="vl">€{formatCurrency(service.totalPrice)}</div>
      <BarTrack value={service.totalPrice} max={maxValue} />
    </div>
  ));

  const isScrolling = duration > 0;

  return (
    <Card title="Verkochte diensten" label={monthLabel} labelHighlight>
      {soldServices.length === 0 ? (
        <div className="empty-note">Nog geen diensten verkocht</div>
      ) : (
        <div
          ref={viewportRef}
          className={`card-scroll${isScrolling ? " is-scrolling" : ""}`}
        >
          <div
            className="card-scroll-track"
            style={{
              rowGap: `${gap}px`,
              animationDuration: isScrolling ? `${duration}s` : undefined,
            }}
          >
            <div className="card-list" ref={listRef} style={{ rowGap: `${gap}px` }}>
              {rows}
            </div>

            {/* Tweede kopie: puur om de lus naadloos te maken. Zodra de eerste
                lijst helemaal weg is gerold, staat de kopie op zijn plek. */}
            {isScrolling && (
              <div className="card-list" aria-hidden="true" style={{ rowGap: `${gap}px` }}>
                {rows}
              </div>
            )}
          </div>
        </div>
      )}
    </Card>
  );
});

export default MostSoldServices;
